import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { eBusLaiXeActionTypeIds, IBusLaiXeActionTypes } from "../../action-types/bus/IBusLaiXeActionTypes";
import { IBusLaiXePageStateModel } from "../../page-state-model/bus/IBusLaiXePageState";

const initialState: IBusLaiXePageStateModel = {
	status: ePageBaseStatus.is_not_initialization,
	bus_laixes: [],
	bus_laixe_editing: undefined,
	bus_laixe_selected_ids: [],
	is_show_delete_confirm: false,
	is_show_detail_modal: false
}

export const busLaiXeReducer = (state: IBusLaiXePageStateModel = initialState, action: IBusLaiXeActionTypes): IBusLaiXePageStateModel => {
	switch (action.type) {
		case eBusLaiXeActionTypeIds.LOAD_START:
			return {
				...state,
				status: ePageBaseStatus.is_loading
			}
		case eBusLaiXeActionTypeIds.LOAD_SUCCESS:
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				bus_laixes: action.payload
			}
		case eBusLaiXeActionTypeIds.LOAD_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				bus_laixes: []
			}
		case eBusLaiXeActionTypeIds.SHOW_DETAIL:
			return {
				...state,
				is_show_detail_modal: true,
				bus_laixe_editing: action.payload
			}
		case eBusLaiXeActionTypeIds.CLOSE_DETAIL:
			return {
				...state,
				is_show_detail_modal: false,
				bus_laixe_editing: undefined
			}
		case eBusLaiXeActionTypeIds.CHANGE_SELECTED_IDS:
			return {
				...state,
				bus_laixe_selected_ids: action.payload
			}
		case eBusLaiXeActionTypeIds.SHOW_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: true
			}
		case eBusLaiXeActionTypeIds.CLOSE_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: false
			}
		case eBusLaiXeActionTypeIds.DELETE_START:
			return {
				...state,
				status: ePageBaseStatus.is_deleting
			}
		case eBusLaiXeActionTypeIds.DELETE_SUCCESS:
			NotifyHelper.Success("Xoá dữ liệu thành công.")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_delete_confirm: false
			}
		case eBusLaiXeActionTypeIds.DELETE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				is_show_delete_confirm: false
			}
		case eBusLaiXeActionTypeIds.SAVE_START:
			return {
				...state,
				status: ePageBaseStatus.is_saving
			}
		case eBusLaiXeActionTypeIds.SAVE_SUCCESS:
			NotifyHelper.Success("Thay đổi dữ liệu thành công.")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_detail_modal: false
			}
		case eBusLaiXeActionTypeIds.SAVE_ERR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				is_show_detail_modal: false
			}
		default:
			return state;
	}
}
